import prodConfig from './config.prod.json';
import devConfig from './config.dev.json';
import testConfig from './config.test.json';

const appConfig = {
  prod: prodConfig,
  dev: devConfig,
  test: testConfig,
};

export default appConfig;
